import { HorizontalSpaceBetween } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ModalHeaderContainer: FunctionComponent<Props> = ({
    children,
    className = '',
    testId = TEST_ID
}) => (
    <HorizontalSpaceBetween
        className={`${className} ${styles.modalHeaderContainer}`}
        testId={testId}>
        {children}
    </HorizontalSpaceBetween>
);

export default ModalHeaderContainer;
